<svg id="spinnerLoaderRef" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" width="100" height="100" overflow="visible" fill="#000000" stroke="#030303" class="single-loader">
  <defs>
    <circle id="spinner" r="4" cx="50" cy="50" transform="translate(0 -30)"/>    
  </defs>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(0 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0s" repeatCount="indefinite"/>
  </use>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(45 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.125s" repeatCount="indefinite"/>
  </use>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(90 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.25s" repeatCount="indefinite"/>
  </use>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(135 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.375s" repeatCount="indefinite"/>
  </use>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(180 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.5s" repeatCount="indefinite"/>
  </use>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(225 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.625s" repeatCount="indefinite"/>
  </use>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(270 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.75s" repeatCount="indefinite"/>
  </use>
  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner" transform="rotate(315 50 50)">
    <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.875s" repeatCount="indefinite"/>
  </use>
</svg>